import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "AsignacionPage",
    data() {
        let ss = new MainService();
        return {
            msg: "AsignacionPage",
            ss: ss,
            ajax: {
                "url": ss.indexAsignacion(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Funcion', name: 'f.Funcion', title: 'Funcion' },
                { data: 'Proyecto', name: 'pr.Proyecto', title: 'Proyecto' },
                { data: 'Fase', name: 'fa.Fase', title: 'Fase' },
                { data: 'Usuario', name: 'p.Usuario', title: 'Usuario' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            asignacions: [],
            asignacion: {},
            funcions: [],
            fases: [],
            usuarios: [],
            proyectos: [],
            selectedUsuario: {},
            selectedProyecto: {},
            queryUsuario: "",
            queryProyecto: "",
            placeholderUsuario: "",
            placeholderProyecto: "",
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        getFuncion() {
            this.ss.listFuncion().then(
                (result) => {
                    let response = result.data;
                    this.funcions = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getFase() {
            this.ss.listFase().then(
                (result) => {
                    let response = result.data;
                    this.fases = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        newAsignacion() {
            this.asignacion = {};
            this.placeholderUsuario = "Escriba el nombre de la Usuario..."
            this.placeholderProyecto = "Escriba el nombre del Proyecto..."
            this.$refs['frm-asignacion'].show();
        },
        showAsignacion(id) {
            this.isLoading = true;
            this.ss.showAsignacion(id).then(
                (result) => {
                    let response = result.data;
                    this.asignacion = response.data;
                    this.$refs['view-asignacion'].show();
                    this.isLoading = false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        },
        editAsignacion() {
            this.$refs['frm-asignacion'].show();
            this.$refs['view-asignacion'].hide();
            this.placeholderUsuario = this.asignacion.usuario ? this.asignacion.usuario.Usuario : "Escriba el nombre de la Usuario...";
            this.placeholderProyecto = this.asignacion.proyecto ? this.asignacion.proyecto.Proyecto : "Escriba el nombre del Proyecto...";
        },
        cancelAsignacion() {
            if (this.asignacion.id) {
                this.$refs['view-asignacion'].show();
            }
            this.$refs['frm-asignacion'].hide();
        },
        saveAsignacion() {
            this.ss.storeAsignacion(this.asignacion).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-asignacion'].hide();
                    this.$refs['datatable-asignacion'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteAsignacion() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyAsignacion(this.asignacion)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-asignacion'].hide();
                                this.$refs['datatable-asignacion'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Asignacion').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showAsignacion(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    watch: {
        queryUsuario(q) {
            this.ss.select2Usuario(q).then((res) => {
                if (res.data.success) {
                    this.usuarios = res.data.items;
                } else {
                    this.usuarios = [];
                }
            })
        },

        queryProyecto(q) {
            this.ss.select2Proyecto(q).then((res) => {
                if (res.data.success) {
                    this.proyectos = res.data.items;
                } else {
                    this.proyectos = [];
                }
            })
        },

    },
    mounted() {
        var usuario = JSON.parse(localStorage.getItem('usuario'));
        if (!usuario) {
            this.$router.push('/Login');
        } else {
            this.getFase();
            this.getFuncion();
        }
    }
};
